/* global $ */
import 'smoothstate';
import EventEmitter from './eventEmitter';

class PageTransitions extends EventEmitter {
  constructor() {
    super();

    this.$container = $('#pjax-container');

    this.options = {
      prefetch: false,
      forms: false,
      onStart: {
        duration: 1500,
        render: this.onTransitionStarted.bind(this),
      },
      onReady: {
        duration: 500,
        render: this.onTransitionReady.bind(this),
      },
      onAfter: this.onTransitionAfter.bind(this),
    };

    this.colors = [
      '#441cc1',
      '#607cff',
      '#8c99c1',
      '#bfc9d8',
      '#dee5ee',
      '#720087',
      '#c14cff',
      '#a88cad',
      '#d1c6d8',
      '#87002d',
      '#ff002d',
      '#b78e8e',
      '#ddbfbf',
      '#915b00',
      '#ff7700',
      '#ad9b7f',
      '#d8ccaf',
      '#5e5600',
      '#d8a300',
      '#999e72',
      '#c6cea5',
      '#005b2d',
      '#89ba00',
      '#7fad96',
      '#bad8c9',
    ];

    this.init();
  }

  init() {
    this.smoothState = this.$container.smoothState(this.options).data('smoothState');
  }

  onTransitionStarted($container) {

    // This check is here because the Algolia default routing clobbers the window.history.state, which is needed by smoothState. These lines add back the missing state.id that Algolia removes when it performs a pushState.
    if (window.history.state.id == null) {
      window.history.replaceState({id: "pjax-container"}, null, null);
    }

    super.emit('modules:deinit');
    $container.addClass('js-exiting');
    this.changeLoaderColor();
    this.smoothState.restartCSSAnimations();
  }

  onTransitionReady($container, $newContent) {
    $container.removeClass('js-exiting');
    $container.html($newContent);
    this.toggleAnnouncement();
  }

  changeLoaderColor() {
    const $loader = $('.js-loader');
    $loader.css('background-color', this.colors[this.getRandomInt(this.colors.length)]);
  }

  getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max));
  }

  toggleAnnouncement() {
    const $announcement = $('.announcement');
    const $body = $('body');
    if (!$announcement.length) {
      $body.removeClass('announcement-active');
    } else {
      $body.addClass('announcement-active');
    }
  }

  onTransitionAfter() {
    super.emit('modules:init');
  }
}

export default PageTransitions;
